// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-filter[data-v-730c992e] .el-drawer__body {\n  overflow: auto;\n  padding-bottom: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
